import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-white relative" data-id="element-9">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-11">
          <h2 className="text-3xl md:text-4xl font-bold text-ocean-900 mb-8" data-id="element-12">
            Your Trusted Partner in Deck Restoration
          </h2>

          <div className="space-y-6 text-lg text-gray-600 leading-relaxed text-left md:text-center" data-id="element-13">
            <p data-id="element-14">
              Welcome to BWC Boat Deck Restoration—your trusted partner for
              bringing boat decks back to life. We specialize in removing,
              restoring, and installing premium boat decks with precision and
              care. Whether your boat deck is worn out, damaged, or simply in
              need of an upgrade, our expert team is ready to deliver top-notch
              results.
            </p>
            <p data-id="element-15">
              At BWC, we understand that your boat is your pride and joy. That's
              why we use the finest materials and the latest techniques to
              ensure your deck looks stunning and stands the test of time. Let
              us transform your boat deck and give it a fresh, safe, and durable
              finish that's ready for your next adventure on the water.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}